import { GetDashboarDataSuccessAction } from "./action";
import { GET_DASHBOARD_DATA_API, GET_DASHBOARD_DATA_API_ERROR, GET_DASHBOARD_DATA_API_SUCCESS } from "./actionTypes";
import { ReportError, ReportErrorOrigin } from "./types";
import { ErrorAction } from "src/common/apiLoader/state/actions";
import { DashboardData } from "src/common/models/report";

export interface ReportState {
    error?: ReportError
    isGettingDashboardData: boolean
    dashboardData?: DashboardData
}

const initialState: ReportState = {
    isGettingDashboardData: false,
}

const reportReducer = (state: ReportState = initialState, action: any): ReportState => {
    switch (action.type) {
        case GET_DASHBOARD_DATA_API: {
            return {
                ...state,
                dashboardData: undefined,
                error: undefined,
            }
        }
        case GET_DASHBOARD_DATA_API_SUCCESS: {
            const successAction = action as GetDashboarDataSuccessAction;

            return {
                ...state,
                dashboardData: successAction.dashboardData,
            }
        }
        case GET_DASHBOARD_DATA_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ReportErrorOrigin.GET_DASHBOARD_DATA,
                    detail: errorAction.error,
                }
            }
        }
    }
    return state;
};

export default reportReducer